import React, { useCallback, useEffect, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import DataTable from '../components/common/Table';
import FilterBar from '../components/common/FilterBar';
import { getSummary } from '../api/stats';
import { StatsSummary, TopVehicle } from '../types';
import './Pages.css';

const COLORS = ['#4CAF50', '#F44336', '#FF9800', '#2196F3', '#9C27B0', '#00BCD4', '#FF5722', '#607D8B'];

const StatsPage: React.FC = () => {
  const [stats, setStats] = useState<StatsSummary | null>(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const load = useCallback(async () => {
    try {
      const res = await getSummary({ start_date: startDate || undefined, end_date: endDate || undefined });
      setStats(res);
    } catch { /* ignore */ }
  }, [startDate, endDate]);

  useEffect(() => { load(); }, [load]);

  const vehicleColumns = [
    { key: 'car_number', label: '차량번호' },
    { key: 'count', label: '과속 횟수' },
    { key: 'max_speed', label: '최고속도', render: (v: TopVehicle) => `${v.max_speed} km/h` },
    { key: 'last_detected', label: '마지막 과속', render: (v: TopVehicle) => new Date(v.last_detected).toLocaleString('ko-KR') },
  ];

  return (
    <div>
      <div className="page-header"><h2>통계</h2></div>
      <FilterBar startDate={startDate} endDate={endDate} onStartDateChange={setStartDate} onEndDateChange={setEndDate} onReset={() => { setStartDate(''); setEndDate(''); }} />

      {stats && (
        <>
          <div className="stats-charts">
            <div className="stats-chart">
              <h3>일별 과속 건수</h3>
              <ResponsiveContainer width="100%" height={300}>
                <BarChart data={[...stats.daily].reverse()}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="date" tick={{ fontSize: 12 }} />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="count" fill="#4CAF50" radius={[4, 4, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </div>

            <div className="stats-chart">
              <h3>장소별 과속 건수</h3>
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie data={stats.by_apartment} dataKey="count" nameKey="apartment_name" cx="50%" cy="50%" outerRadius={100} label={(entry) => `${(entry as unknown as { apartment_name: string }).apartment_name} (${(entry as unknown as { count: number }).count})`}>
                    {stats.by_apartment.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>

          <div className="stats-section">
            <h3>최다 과속 차량 TOP 10</h3>
            <DataTable columns={vehicleColumns} data={stats.top_vehicles} />
          </div>
        </>
      )}
    </div>
  );
};

export default StatsPage;
